import { SocialMediaButton } from "../../components/SocialMediaButton"
import styles from "../../styles.module.scss"
import { SelectCreatableInputWithChips } from "../../../../../../atoms/SelectCreatableInputWithChips"
import { colors } from "@theme/colors"

export const SocialSellingTab = () => {
  return (
    <>
      <div className={styles.agencyInfoContainer}>
        <div className={styles.sectionInfo}>
          <p className={styles.sectionTitle}>Social media integration</p>
          <p className={styles.sectionDescription}>Connect to manage all in one place.</p>
        </div>
        <div className={styles.agencyInfoForm}>
          <div className={styles.socialMediaWrapper}>
            <SocialMediaButton socialMediaName="facebook" onClick={() => {}} />
          </div>
        </div>
      </div>
      <div className={styles.divider} />
      <div className={styles.agencyInfoContainer}>
        <div className={styles.sectionInfo}>
          <p className={styles.sectionTitle}>Lead trigger</p>
          <p className={styles.sectionDescription}>
            Define keywords to initiate Facebook lead capture.
          </p>
        </div>
        <div className={styles.agencyInfoForm}>
          <SelectCreatableInputWithChips
            name="keywords"
            label="Keywords"
            parentBackgroundColor={colors.backgroundSecondary}
          />
        </div>
      </div>
    </>
  )
}
